import { useState } from "react";
import { Filter, ChevronDown, Check } from "lucide-react";
import { useInfrastructureCache } from "../../../hooks/useInfrastructureCache";

const VmFilter = ({ selectedVmId, onVmChange }) => {
  const [isVmFilterOpen, setIsVmFilterOpen] = useState(false);
  const { data: infrastructure } = useInfrastructureCache();
  const vmList = infrastructure?.vms || [];

  const getVmName = () => {
    if (selectedVmId === 0) return "All VMs";
    const vm = vmList.find(v => v.id === selectedVmId);
    return vm ? vm.name : "All VMs";
  };

  const handleVmSelect = (vmId) => {
    onVmChange(vmId);
    setIsVmFilterOpen(false);
  };

  return (
    <div className="relative w-full sm:w-auto">
      <button
        onClick={() => setIsVmFilterOpen(!isVmFilterOpen)}
        className="flex items-center justify-between gap-2 px-3 sm:px-4 py-2 bg-primary-cyan text-white rounded-lg hover:opacity-90 transition-all font-medium w-full sm:w-auto min-w-[160px] sm:min-w-[180px] text-sm sm:text-base"
      >
        <span className="flex items-center gap-2 truncate">
          <Filter size={16} className="sm:w-[18px] sm:h-[18px]" />
          <span className="truncate">{getVmName()}</span>
        </span>
        <ChevronDown size={14} className={`transition-transform sm:w-4 sm:h-4 ${isVmFilterOpen ? 'rotate-180' : ''}`} />
      </button>

      {isVmFilterOpen && (
        <div className="absolute top-full left-0 right-0 sm:right-auto mt-2 bg-card-bg rounded-xl shadow-lg border border-border-color z-50 min-w-[200px] max-h-80 overflow-y-auto">
          <button
            onClick={() => handleVmSelect(0)}
            className={`w-full text-left px-4 py-2 text-sm hover:bg-bg-main transition-colors flex items-center justify-between ${
              selectedVmId === 0 ? 'bg-bg-main text-primary-cyan' : 'text-primary-dark'
            }`}
          >
            All VMs
            {selectedVmId === 0 && <Check size={14} />}
          </button>
          
          <div className="border-t border-border-color my-1" />
          
          {vmList.map(vm => (
            <button
              key={vm.id}
              onClick={() => handleVmSelect(vm.id)}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-bg-main transition-colors flex items-center justify-between ${
                selectedVmId === vm.id ? 'bg-bg-main text-primary-cyan' : 'text-primary-dark'
              }`}
            >
              <span className="truncate">{vm.name}</span>
              {selectedVmId === vm.id && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default VmFilter;